<template>
	<div class="media">
  		<span class="align-self-center mr-3 font-weight-bold">
  			<i class="material-icons text-secondary" v-tooltip="title">{{icon}}</i>
  		</span>
  		<div class="media-body">
  			<slot></slot>
  		</div>
  	</div>
</template>
<script>
	export default {
		props: ['title', 'icon'],
	}
</script>